import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { ExportService } from '../shared/services/exportservice';

import { CommonModule } from '@angular/common';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'app-date-of-result',
  imports: [CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './date-of-result.component.html',
  styleUrl: './date-of-result.component.scss'
})
export class DateOfResultComponent {
dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','month','year','date','createdAt'],
   cols: ['sno','month','year','date','createdAt']
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  display = true;
  months: any;
  years: any;
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 CourseId: string | null = null;
 
 isdateofresultList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
   private exportService: ExportService
 ) {
   this.formGroup = this.fb.group({
    selectedMonth: ['', Validators.required],
    selectedYear: ['', Validators.required],
    date: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  this.year_list();
    this.month_list();
   this.getDateOfresultList();
 }
// router.post('/addDateOfresult', SettingsController.AddResultDate);
// router.get('/getDateOfresultList', SettingsController.getdateOfResultList);
// router.put('/updateDateOfresult/:id', SettingsController.updatedateOfResult);
// router.put('/deleteDateOfresult/:id', SettingsController.deletedateOfResult);

 

 getDateOfresultList(): void {
   this.isdateofresultList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getDateOfresultList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No settings found or empty settings array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching settings information:', error);
       this.common.notification('Error loading settings information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isdateofresultList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isdateofresultList=false;   
   this.CourseId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
    date: row.date,
    selectedMonth: row.month,
    selectedYear: row.year,
   });
 }
   


 savedateOfResult(): void {
   this.isdateofresultList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   const data={
    month:this.formGroup.value.selectedMonth,
    year:this.formGroup.value.selectedYear,
    date:this.formGroup.value.date,
   }
   if (this.CourseId) {
        
     this.api.put(`settings/updateDateOfresult/${this.CourseId}`, data).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addDateOfresult`,data,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getDateOfresultList();
     this.resetForm();
   }
 }
 



 addDateOfResult(){
   this.resetForm();
   this.isdateofresultList=false;
 }
 


back(){
 this.isEdit=false;
 this.isdateofresultList=true;  
 this.resetForm();
 this.CourseId=null;
 this.getDateOfresultList();
}

delete(row:any)
{

 const courseId=row.id;
 this.api.put(`settings/deleteDateOfresult/${courseId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getDateOfresultList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getDateOfresultList();
}


 year_list() {
    this.api.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.api.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

}
